<template>
	<div>
		<v-row class="ma-0 py-1 total-value-container" justify="center" align="center">
			<div style="min-width: 100px;">
				<div class="font-bold-style selector-item-style">
					Supplier Amount
					<v-tooltip v-if="totalValue.rate === link" top color="#192A3E" max-width="250">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="warning" :size="20">mdi-information</v-icon>
						</template>
						<span>Job contains more than 1 currency. Show values in divisional currency to see a total.</span>
					</v-tooltip>
				</div>
				<div class="font-text-style">
					<span v-if="totalValue.rate === link">--</span>
					<span v-else>
						<span v-if="totalValue.rate.length !== 0" class="currency-style">{{ totalValue.rate.split(link)[0] }}&nbsp;</span>
						<span>{{ totalValue.rate.split(link)[1] }}&nbsp;</span>
					</span>
				</div>
			</div>
			<v-divider vertical color="#C4C4C4" class="mx-4"></v-divider>
			<div style="min-width: 100px;">
				<div class="font-bold-style selector-item-style">
					Commission
					<v-tooltip v-if="totalValue.commission === link" top color="#192A3E" max-width="250">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="warning" :size="20">mdi-information</v-icon>
						</template>
						<span>Job contains more than 1 currency. Show values in divisional currency to see a total.</span>
					</v-tooltip>
				</div>
				<div class="font-text-style">
					<span v-if="totalValue.commission === link">--</span>
					<span v-else>
						<span v-if="totalValue.commission.length !== 0" class="currency-style">{{ totalValue.commission.split(link)[0] }}&nbsp;</span>
						<span>{{ totalValue.commission.split(link)[1] }}&nbsp;</span>
					</span>
				</div>
			</div>
			<v-divider vertical color="#C4C4C4" class="mx-4"></v-divider>
			<div style="min-width: 100px;">
				<div class="font-bold-style selector-item-style">
					Net
					<v-tooltip v-if="totalValue.net === link" top color="#192A3E" max-width="250">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="warning" :size="20">mdi-information</v-icon>
						</template>
						<span>Job contains more than 1 currency. Show values in divisional currency to see a total.</span>
					</v-tooltip>
				</div>
				<div class="font-text-style">
					<span v-if="totalValue.net === link">--</span>
					<span v-else>
						<span v-if="totalValue.net.length !== 0" class="currency-style">{{ totalValue.net.split(link)[0] }}&nbsp;</span>
						<span>{{ totalValue.net.split(link)[1] }}&nbsp;</span>
					</span>
				</div>
			</div>
			<v-divider vertical color="#C4C4C4" class="mx-4"></v-divider>
			<div style="min-width: 100px;">
				<div class="font-bold-style selector-item-style">
					Bill to client
					<v-tooltip v-if="totalValue.bill === link" top color="#192A3E" max-width="250">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="warning" :size="20">mdi-information</v-icon>
						</template>
						<span>Job contains more than 1 currency. Show values in divisional currency to see a total.</span>
					</v-tooltip>
				</div>
				<div class="font-text-style">
					<span v-if="totalValue.bill === link">--</span>
					<span v-else>
						<span v-if="totalValue.bill.length !== 0" class="currency-style">{{ totalValue.bill.split(link)[0] }}&nbsp;</span>
						<span>{{ totalValue.bill.split(link)[1] }}&nbsp;</span>
					</span>
				</div>
			</div>
			<v-divider vertical color="#C4C4C4" class="mx-4"></v-divider>
			<div style="min-width: 100px;">
				<div class="font-bold-style selector-item-style">
					Revenue %
					<v-tooltip v-if="totalValue.revenue_perc === link" top color="#192A3E" max-width="250">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="warning" :size="20">mdi-information</v-icon>
						</template>
						<span>Job contains more than 1 currency. Show values in divisional currency to see a total.</span>
					</v-tooltip>
				</div>
				<div class="font-text-style">
					<span v-if="totalValue.revenue_perc === link">--</span>
					<span v-else>
						<span v-if="totalValue.revenue_perc.length !== 0" class="currency-style">{{ totalValue.revenue_perc.split(link)[0] }}&nbsp;</span>
						<span>{{ totalValue.revenue_perc.split(link)[1] }}&nbsp;</span>
					</span>
				</div>
			</div>
			<v-divider vertical color="#C4C4C4" class="mx-4"></v-divider>
			<div style="min-width: 100px;">
				<div class="font-bold-style selector-item-style">
					Revenue $
					<v-tooltip v-if="totalValue.revenue === link" top color="#192A3E" max-width="250">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="warning" :size="20">mdi-information</v-icon>
						</template>
						<span>Job contains more than 1 currency. Show values in divisional currency to see a total.</span>
					</v-tooltip>
				</div>
				<div class="font-text-style">
					<span v-if="totalValue.revenue === link">--</span>
					<span v-else>
						<span v-if="totalValue.revenue.length !== 0" class="currency-style">{{ totalValue.revenue.split(link)[0] }}&nbsp;</span>
						<span>{{ totalValue.revenue.split(link)[1] }}&nbsp;</span>
					</span>
				</div>
			</div>
			<v-divider vertical color="#C4C4C4" class="mx-4"></v-divider>
			<div style="min-width: 100px;">
				<div class="font-bold-style selector-item-style">
					3rd party commission
					<v-tooltip v-if="totalValue.party === link" top color="#192A3E" max-width="250">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="warning" :size="20">mdi-information</v-icon>
						</template>
						<span>Job contains more than 1 currency. Show values in divisional currency to see a total.</span>
					</v-tooltip>
				</div>
				<div class="font-text-style">
					<span v-if="totalValue.party === link">--</span>
					<span v-else>
						<span v-if="totalValue.party.length !== 0" class="currency-style">{{ totalValue.party.split(link)[0] }}&nbsp;</span>
						<span>{{ totalValue.party.split(link)[1] }}&nbsp;</span>
					</span>
				</div>
			</div>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'MediaPlanTotalTable',
	props: {
		color: {
			type: String,
			default: '',
		},
		totalValue: {
			type: Object,
			default: null,
		}
	},
	data() {
		this.link = '_';

		return {}
	},
	components: {
	},
	created() {
	},
	computed: {
	},
	methods: {
	}
}
</script>

<style lang="scss" scoped>
.total-value-container {
	height: 64px;
	background-color: #192A3E;
	color: #FFFFFF;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	letter-spacing: 0.4px;
}
.font-text-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
}
.currency-style {
	color: #C4C4C4;
}
.selector-item-style {
	color: #605AF6;
}
</style>